import { Navigate } from "react-router-dom";
import { useSubscription } from "@/context/SubscriptionContext";
import { Lock } from "lucide-react";

/**
 * Wrap a route element to gate it behind a package feature.
 * If the feature is not enabled in the current package, render a friendly
 * "upgrade required" placeholder (and the backend would 403 anyway).
 *
 *   <Route path="quotation" element={<FeatureGate feature="quotations"><Quotation /></FeatureGate>} />
 */
export const FeatureGate = ({ feature, children }) => {
  const { hasFeature, ready, package: pkg } = useSubscription();
  if (!ready) return null;             // Wait for state to load to avoid flash
  if (hasFeature(feature)) return children;
  return (
    <div className="min-h-[60vh] flex items-center justify-center p-6" data-testid="feature-locked-screen">
      <div className="max-w-md text-center space-y-4 bg-gray-900/60 border border-amber-500/30 rounded-xl p-8">
        <Lock className="h-12 w-12 mx-auto text-amber-400" />
        <h2 className="text-2xl font-bold text-white">Pro Feature</h2>
        <p className="text-gray-300 text-sm">
          This page is only available in the <b className="text-amber-300">Pro</b> package.
          You're currently on the <b>{pkg}</b> package.
        </p>
        <p className="text-xs text-gray-500">
          Please contact your software vendor to upgrade.
        </p>
      </div>
    </div>
  );
};

export default FeatureGate;
